/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@material-ui/core';
// import PropTypes from 'prop-types';

import Carousel from 'react-material-ui-carousel';
import { Paper } from '@mui/material';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import SuggestTable from '../../component/SuggestTable/index.jsx';
import firebase from "../../config/firebase/index";
import EditIcon from '@mui/icons-material/Edit';
import style from './style';
import encSecret from '../../config/encryption/index.js';
import Drawer from '@material-ui/core/Drawer';
import Suggest_Bid from '../../pages/Suggest_Bid/Suggest_Bid.js';
import MessageAtom from '../MessagAtom/index.jsx';

var CryptoJS = require("crypto-js");


const BidsAtom = (props) => {
  const classes = style();
  const [bid, setBid] = useState({});
  const [show, setShow] = useState(false);
  const [more, setMore] = useState(true);
  const [openSuggest, setOpenSuggest] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [deal, setDeal] = useState({});

  useEffect(() => {
    setLoggedIn(localStorage.getItem('isLoggedIn'));
    let bid = props.bid;
    firebase.database().ref(`Product/${props.bid.DealId}`).on("value", snapshot => {

      bid["deal"] = snapshot.val();
      setDeal(snapshot.val());
      console.log(bid);
      setBid(bid);
    })
    // console.log(props.bid);
  }, [])

  const edit = () => {
    setOpenSuggest(true);
    // console.log("Updating user");
    //     const editRef = firebase.database().ref('Customer/' + bid.id);
    //     editRef.update({
    //         "Name": CryptoJS.AES.encrypt(name, encSecret.key).toString(),
    //         "PhoneNo": PhoneNo,
    //         "City": city,
    //         "img": image ? image : "",
    //         "updatedAt": new Date().toISOString(),
    //         // "optInDateTime" : updateWAOptIn && user[0].whatsappOptIn ? new Date().toISOString() : user[0].optInDateTime,
    //         // "optOutDateTime" : updateWAOptIn && !user[0].whatsappOptIn ? new Date().toISOString() : ""
    //     });
    //     profileSave('Edit Profile', 'Click', 'Save profile button');
    //     history.push("/profile");

  }

  const onClose = (val) => {
    firebase.database().ref(`Customer/${props.bid.id}`).on("value", snapshot => {

      let bid = snapshot.val();
      bid["id"] = props.bid.id;
      bid["deal"] = deal;
      console.log("BID :: ", bid, deal);
      setBid(bid);
    })
    setOpenSuggest(val);

  }


  return (
    <Box m={2}>
      {
        bid && bid.deal ?
          <Box style={{ boxShadow: '0 10px 10px 0 #ddd' }}>
            <Box style={{ display: "grid", gridTemplateColumns: "35% 65%" }} onClick={() => { setShow(!show) }}>
              <Box style={{ padding: 10 }}>
                <img src={bid.deal.image} width={"100%"} />
              </Box>
              <Box style={{ padding: 10 }}>
                <Box style={{ display: "grid", gridTemplateColumns: "65% 35%" }}>
                  <Box>
                    <Typography style={{ fontSize: 14, fontWeight: 600, padding: "0px 5px" }}>{bid.deal.productName}</Typography>
                  </Box>
                  <Box>
                    <Typography style={{ fontSize: 14, fontWeight: 600, padding: "0px 5px" }}>Rs.{bid.price}</Typography>
                  </Box>
                </Box>
                <Box style={{ display: "grid", gridTemplateColumns: "65% 35%" }}>
                  <Box>
                    <Typography style={{ fontSize: 12, padding: "0px 5px" }}>वस्तु</Typography>
                  </Box>
                  <Box>
                    <Typography style={{ fontSize: 12, padding: "5px 5px" }}>क़ीमत</Typography>
                  </Box>
                </Box>
                <Box style={{ display: "grid", gridTemplateColumns: "85% 15%" }}>
                  <Box style={{ fontSize: 14, padding: "0px 5px" }}>{bid.deal.Place} | {bid.quantity ? bid.quantity : "-"}</Box>
                  <Box style={{ fontSize: 14, padding: "0px 5px" }}><EditIcon onClick={edit} /></Box>
                </Box>
              </Box>

            </Box>
            {
              show ?
                <>
                  <Box style={{ padding: "5px 20px" }}>
                    <Typography style={{ fontSize: 14, fontWeight: 600 }}>
                      सौदे की मूल कीमत - Rs. {CryptoJS.AES.decrypt(bid.deal.Max, encSecret.key).toString(CryptoJS.enc.Utf8)}-{CryptoJS.AES.decrypt(bid.deal.Max, encSecret.key).toString(CryptoJS.enc.Utf8)}*
                    </Typography>
                  </Box>
                  <Box style={{ padding: "5px 10px" }}>
                    <MessageAtom message={bid.deal.Message} len={46} />
                    {bid.DealId ?
                      <Box mt={1} >
                        <SuggestTable id={bid.DealId} />
                      </Box>
                      : <></>
                    }
                  </Box>
                </>


                :
                <></>
            }
          </Box>
          :
          <></>
      }
      <React.Fragment>
        <Drawer className={classes.drawerDesign} anchor={'bottom'} open={openSuggest}>
          <Suggest_Bid closePopUp={onClose} methodFlag={"suggest"} quantityUnit={bid.quantityUnit} selectedDeal={bid.DealId} date={new Date()} suggestId={bid.id} loggedIn={loggedIn ? loggedIn : false} />
        </Drawer>
      </React.Fragment>
    </Box>
  );
}

export default BidsAtom;